import type { FileBrowserRequestMessage } from '../../../../files/browser/types.js';

export function parseOptionalInt(raw: string | null): number | undefined {
  if (raw == null) return undefined;
  const parsed = parseInt(raw, 10);
  return Number.isInteger(parsed) ? parsed : undefined;
}

export function parseGitScopeFromUrl(url: URL): Pick<FileBrowserRequestMessage, 'source' | 'repoRelPath' | 'branch'> {
  const rawSource = url.searchParams.get('source')?.trim();
  if (rawSource === 'git_branch') {
    return {
      source: 'git_branch',
      repoRelPath: url.searchParams.get('repoRelPath')?.trim() ?? '.',
      branch: url.searchParams.get('branch')?.trim() ?? '',
    };
  }
  return { source: 'filesystem' };
}

export function parseReadParams(url: URL): Pick<
  FileBrowserRequestMessage,
  'startLine' | 'endLine' | 'lineOffset' | 'lineChunkSize' | 'encoding'
> {
  const rawEncoding = url.searchParams.get('encoding');
  return {
    startLine: parseOptionalInt(url.searchParams.get('startLine')),
    endLine: parseOptionalInt(url.searchParams.get('endLine')),
    lineOffset: parseOptionalInt(url.searchParams.get('lineOffset')),
    lineChunkSize: parseOptionalInt(url.searchParams.get('lineChunkSize')),
    encoding: rawEncoding === 'base64' ? 'base64' : 'utf8',
  };
}

export function parseListPath(url: URL): string {
  return (url.searchParams.get('path') ?? '.').replace(/^\/+/, '') || '.';
}

export function parseReadPath(url: URL): string | null {
  const raw = url.searchParams.get('path')?.trim();
  if (!raw) return null;
  return raw.replace(/^\/+/, '') || '.';
}
